var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    `${_vm.carbonPrefix}--list-box ${_vm.carbonPrefix}--dropdown ${_vm.carbonPrefix}--skeleton`,
    { [`${_vm.carbonPrefix}--list-box--inline`]: _vm.inline },
  ],attrs:{"disabled":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }